const ARTICLEROWSPERPAGE = 5;

export default ARTICLEROWSPERPAGE;